import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/PancakePairABI.json";
import { web3Reader } from "src/wallet-connection";

const { PANCAKE_PAIR } = getCurrentContractAddresses();
var contractReader = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, PANCAKE_PAIR);
  }
  return contractReader;
}

async function getReserves() {
  const res = await getContractReader().methods.getReserves().call();
  return res;
}

async function getBalanceLP(accountAddress) {
  const res = await getContractReader().methods.balanceOf(accountAddress).call();
  return res;
}

async function getTotalSupply() {
  const res = await getContractReader().methods.totalSupply().call();
  return res;
}

export default {
  ABI,
  ADDRESS: PANCAKE_PAIR,
  getReserves,
  getBalanceLP,
  getTotalSupply,
};
